import { styled } from "../../styles";

export interface ListItemProps {}

export const ListItem = styled.li<ListItemProps>`
  color: inherit;
`;
